export enum ROUTE_ME {
  HOME = 'me',

  PROFILE_WEBSITE = 'me-profile-index-website',
  PROFILE_SKILL = 'me-profile-index-skill',
  PROFILE_LANGUAGE = 'me-profile-index-language',
  PROFILE_INTEREST = 'me-profile-index-interest',
  PROFILE_HOME = 'me-profile-index',
  PROFILE_EXPERIENCE = 'me-profile-index-experience',
  PROFILE_EDUCATION = 'me-profile-index-education',

  PERSONAL_SPACE_SETTINGS = 'me-personal-space-settings',
  PERSONAL_SPACE_WIKI = 'me-personal-space-index-wiki',
  PERSONAL_SPACE_WEDO = 'me-personal-space-index-wedo',
  PERSONAL_SPACE_MEDIA = 'me-personal-space-index-media',
  PERSONAL_SPACE_HOME = 'me-personal-space-index',
  PERSONAL_SPACE_IDEA = 'me-personal-space-index-idea',
  PERSONAL_SPACE_CONTENT_TYPE = 'me-personal-space-index-content_type',

  DRAFTS_MEDIA = 'me-drafts-index-media',
  DRAFTS_HOME = 'me-drafts-index',
  DRAFTS_CONTENT_TYPE = 'me-drafts-index-content_type',

  CONTRIBUTIONS_MEDIA = 'me-contributions-index-media',
  CONTRIBUTIONS_HOME = 'me-contributions-index',
  CONTRIBUTIONS_CONTENT_TYPE = 'me-contributions-index-content_type',

  ACTIVITY_MEDIA = 'me-activity-index-media',
  ACTIVITY_HOME = 'me-activity-index',
  ACTIVITY_CONTENT_TYPE = 'me-activity-index-content_type',

  SECURITY = 'me-security',
  
  REQUESTS = 'me-requests',

  RECYCLE_BIN = 'me-recycle-bin',

  PREFERENCES = 'me-preferences',

  ORGANIZATION = 'me-organization',

  BOOKMARKS = 'me-bookmarks',
}
